// @flow
import React from 'react';
import {Link} from '@homeaway/react-localization-components';
import {DualPrice} from '../../DualPrice/DualPrice';
import RoomsBedsDetails from './Details/RoomsBedsDetails/RoomsBedsDetails';
import {AddressDetails} from './Details/PropertyDetails/PropertyDetails';
import {SuperlativeBadge, NewListingBadge, RankedBadges} from './Badges/Badges';
import WebRatingBadge from '../../WebRatingBadge/WebRatingBadge';
import ColorizedRating from '../../Rating/ColorizedRating/ColorizedRating';

import type {Props as HitInfoProps} from './HitExperimentInfo';

// TODO: move minStay logic to lingua
// https://jira.homeawaycorp.com/browse/SERP-2848
export default function HitInfoMobile({intl, listing, onClick}: HitInfoProps) {
    const superlativesBadges = listing.superlativesBadges || [];
    const rankedBadges = listing.rankedBadges || [];
    const webRatingBadges = listing.webRatingBadges || [];
    const showWebRatingBadge =
        listing.reviewCount === 0 && webRatingBadges && webRatingBadges.length;

    const DualPriceWrapper = () => {
        return (
            <div className="HitExperimentInfo__priceSuperlativeGroup">
                <DualPrice
                    listing={listing}
                    intl={intl}
                    isDesktop={false}
                    showInstantBookIcon={false}
                    withTooltip
                />
                <SuperlativeBadge superlativesBadges={superlativesBadges} />
                <NewListingBadge superlativesBadges={superlativesBadges} />
            </div>
        );
    };

    return (
        <div className="HitExperimentInfo__content">
            <Link
                target={'_blank'}
                className="media-flex__content"
                href={listing.detailPageUrl}
                onClick={onClick}
                tabIndex="0"
            >
                <div className="HitExperimentInfo__starRating">
                    {showWebRatingBadge ? (
                        <WebRatingBadge
                            badge={webRatingBadges[0]}
                            renderStarIcon
                        />
                    ) : (
                        <ColorizedRating listing={listing} />
                    )}
                    <RankedBadges rankedBadges={rankedBadges} />
                </div>
                <AddressDetails listing={listing} />
                <RoomsBedsDetails listing={listing} />
            </Link>
            <div className="media-flex__left">
                <DualPriceWrapper />
            </div>
        </div>
    );
}
